"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const consts_1 = __importDefault(require("../consts"));
// @jen placeholder schema + validator
var Version1Point0;
(function (Version1Point0) {
    // const schema = {};
    Version1Point0.validate = (test) => {
        if (test) {
            return true;
        }
        return { errors: [] };
    };
})(Version1Point0 || (Version1Point0 = {}));
const Version = {
    [finley_types_1.CreditAgreement.DomainEntity.CreditAgreementSchemaVersion['1.0']]: Version1Point0,
};
const validate = (test, schemaVersion) => {
    switch (schemaVersion) {
        case finley_types_1.CreditAgreement.DomainEntity.CreditAgreementSchemaVersion['1.0']:
            return Version[finley_types_1.CreditAgreement.DomainEntity.CreditAgreementSchemaVersion['1.0']].validate(test);
        default:
            // if no schema version provided, assumes current schema version
            return Version[finley_types_1.CreditAgreement.DomainEntity.CreditAgreementSchemaVersion[consts_1.default.CURRENT_CREDIT_AGREEMENT_DOCUMENT_SCHEMA_VERSION]].validate(test);
    }
};
exports.validate = validate;
//# sourceMappingURL=creditAgreementFullArtifact.js.map